// extracted by css-extract-rspack-plugin
export default {"branchName":"PullRequestBranchName-module__branchName__SCtl2","branchWithButton":"PullRequestBranchName-module__branchWithButton__lvOVA"};